import { render, staticRenderFns } from "./NavbarGiftBox.vue?vue&type=template&id=28eb4069&scoped=true&"
import script from "./NavbarGiftBox.vue?vue&type=script&lang=js&"
export * from "./NavbarGiftBox.vue?vue&type=script&lang=js&"
import style0 from "./NavbarGiftBox.vue?vue&type=style&index=0&id=28eb4069&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb4069",
  null
  
)

export default component.exports